import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';

function Layout() {
  const location = useLocation();
  return (
    <>
      <Header />
      <div key={location.pathname} className="page-transition">
        <Outlet />
      </div>
      <div className="__screenGuard">
        <p>This experience requires a larger screen. Please view on a device that is at least 1024px wide.</p>
      </div>
    </>
  );
}

export default Layout;
